import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Add } from '@mui/icons-material';
import { Box, Typography, Tooltip, IconButton, Avatar } from '@mui/material';
import { useStyles } from '../styles/sectionStyles';
import { isAdmin } from '../../../utils/share';
import { PROJECT_EDITOR_ROLE } from '../../../Constants/ProjectConstants';

const SectionHeader = ({ section, taskCount, onAddClick }) => {
  const navigate = useNavigate();
  const classes = useStyles();
  const accountData = useSelector((state) => state?.login?.user);

  const goToProjects = () => {
    navigate(`/project/board/${section?.id}`);
  };

  const handleAddTaskClick = () => {
    onAddClick(section);
  };

  let projectmember = section?.projectmember;
  if (Array.isArray(projectmember)) {
    projectmember = projectmember.find((data) => data.userId === accountData?.id);
  }

  const projectRole = projectmember?.projectRoles?.roleName ?? '';

  const isEditPermission = isAdmin() || PROJECT_EDITOR_ROLE.includes(projectRole);

  function stringAvatar(name) {
    if (!name) return {};
    return {
      sx: {
        textAlign: 'center',
        bgcolor: 'inherit',
        border: '1px solid #000',
        // BorderColor: stringToColor(name),
        color: '#000',
      },
      children: `${name}`,
    };
  }
  const createTaskDisabled = !section?.allowManualTask && !isEditPermission;
  return (
    <header className={classes.header}>
      <Box className={classes.titleBox}>
        <Tooltip title={section?.projectName} placement="top" arrow>
          <Typography variant="h6" noWrap className={classes?.projectName} onClick={goToProjects}>
            {section?.projectName}
          </Typography>
        </Tooltip>

        <Tooltip title={`${taskCount} task${taskCount === 1 ? '' : 's'} in this section`} placement="top" arrow>
          <Avatar {...stringAvatar(taskCount.toString())} className={classes?.avatar} />
        </Tooltip>
      </Box>
      {!createTaskDisabled && (
        <Box className={classes.actionBox}>
          <Tooltip title="Add Task" placement="top" arrow>
            <IconButton size="small" onClick={handleAddTaskClick}>
              <Add fontSize="small" />
            </IconButton>
          </Tooltip>
        </Box>
      )}
    </header>
  );
};

SectionHeader.propTypes = {
  section: PropTypes.object,
  onAddClick: PropTypes.func,
  taskCount: PropTypes.number,
};

export default SectionHeader;
